import React from 'react';
import { CheckCircle2Icon, AlertTriangleIcon, XCircleIcon, Loader2Icon, CircleDashedIcon } from 'lucide-react';
import type { DestinationRunStatus, UploadStatus, ValidationStatus, Severity } from '../../lib/types';
import { cn } from '../../lib/utils';
type AnyStatus = DestinationRunStatus | UploadStatus | ValidationStatus | Severity;
const CONFIG: Record<string, {
  label: string;
  className: string;
  icon: React.ElementType | null;
  spin?: boolean;
}> = {
  // destination / upload
  waiting: {
    label: 'Waiting',
    className: 'bg-gray-100 text-gray-600',
    icon: CircleDashedIcon
  },
  processing: {
    label: 'Processing',
    className: 'bg-blue-50 text-salesforce-700',
    icon: Loader2Icon,
    spin: true
  },
  completed: {
    label: 'Completed',
    className: 'bg-emerald-50 text-emerald-700',
    icon: CheckCircle2Icon
  },
  'completed-with-warnings': {
    label: 'Completed with warnings',
    className: 'bg-amber-50 text-amber-700',
    icon: AlertTriangleIcon
  },
  'partially-completed': {
    label: 'Partially completed',
    className: 'bg-amber-50 text-amber-700',
    icon: AlertTriangleIcon
  },
  failed: {
    label: 'Failed',
    className: 'bg-red-50 text-red-700',
    icon: XCircleIcon
  },
  // validation / severity
  valid: {
    label: 'Valid',
    className: 'bg-emerald-50 text-emerald-700',
    icon: CheckCircle2Icon
  },
  warning: {
    label: 'Warning',
    className: 'bg-amber-50 text-amber-700',
    icon: AlertTriangleIcon
  },
  error: {
    label: 'Error',
    className: 'bg-red-50 text-red-700',
    icon: XCircleIcon
  }
};
interface Props {
  status: AnyStatus;
  labelOverride?: string;
  size?: 'sm' | 'md';
  className?: string;
}
export function StatusBadge({
  status,
  labelOverride,
  size = 'md',
  className
}: Props) {
  const cfg = CONFIG[status] ?? CONFIG.waiting;
  const Icon = cfg.icon;
  return <span className={cn('inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap', size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs', cfg.className, className)} data-id="element-300" data-mp="26yyio2ytxi94">
      {Icon && <Icon className={cn(size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5', cfg.spin && 'animate-spin')} data-id="element-301" data-mp="3r6irihfkhsa" />}
      {labelOverride ?? cfg.label}
    </span>;
}